/**
 * KK2 Card JS
 *  1. mountExtras(): relocates each .kk2-extras layer into the media block of
 *     its NATIVE Horizon product card, so overlays sit on the image — robust
 *     against any gallery class names (finds the top-level block containing an <img>).
 *     Re-runs via MutationObserver (AJAX filtering / pagination in collections).
 *  2. Swatch hover/click swaps the card image instantly (no fetch — the variant
 *     image URL is pre-rendered by Liquid in data-image).
 *  3. Legacy handlers for the old kk2-product-grid section + KK2QuickView trigger.
 */
(function () {
  'use strict';

  /* ---------- 1. mount extras into the media block ---------- */
  function mountExtras() {
    document.querySelectorAll('.kk2-extras[data-kk2-unmounted]').forEach(function (ex) {
      var card = ex.closest('product-card');
      if (!card) return;
      var content = card.querySelector('.product-card__content');
      if (!content) return;
      var img = content.querySelector('img');
      if (!img) return;
      // climb to the top-level child of content that contains the image
      var host = img;
      while (host.parentElement && host.parentElement !== content) {
        host = host.parentElement;
      }
      if (host === content || host === ex) return;
      var pos = window.getComputedStyle(host).position;
      if (pos === 'static') host.style.position = 'relative';
      host.appendChild(ex);
      ex.removeAttribute('data-kk2-unmounted');
      ex.classList.add('is-mounted');
    });
  }

  var rafPending = false;
  function scheduleMount() {
    if (rafPending) return;
    rafPending = true;
    window.requestAnimationFrame(function () {
      rafPending = false;
      mountExtras();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountExtras);
  } else {
    mountExtras();
  }
  if (window.MutationObserver) {
    new MutationObserver(scheduleMount).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  /* ---------- 2. swatch -> instant image swap ---------- */
  function swapImage(swatch) {
    var url = swatch.getAttribute('data-image');
    if (!url) return;
    var card = swatch.closest('product-card');
    if (!card) return;
    var img = card.querySelector('.product-card__content img');
    if (!img) return;
    img.removeAttribute('srcset');
    img.src = url;
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('[data-kk2-ex-swatch]');
    if (sw) swapImage(sw);
  });

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-kk2-ex-swatch]');
    if (sw) {
      e.preventDefault();
      e.stopPropagation();
      swapImage(sw);
      var group = sw.closest('.kk2-extras__swatches');
      if (group) {
        group.querySelectorAll('.kk2-extras__swatch').forEach(function (b) {
          b.classList.remove('is-selected');
        });
      }
      sw.classList.add('is-selected');
      return;
    }
    // size links: let them navigate to product.url?variant=ID,
    // but stop the card's own click handlers from hijacking
    var sz = e.target.closest('a.kk2-extras__size');
    if (sz) {
      e.stopPropagation();
      return;
    }

    /* ---------- 3. legacy: old kk2-product-grid cards ---------- */
    var legacySw = e.target.closest('[data-kk2-swatch]');
    if (legacySw) {
      e.preventDefault();
      legacySw
        .closest('kk2-product-card')
        ?.querySelectorAll('[data-kk2-swatch]')
        .forEach(function (s) {
          s.classList.remove('is-selected');
        });
      legacySw.classList.add('is-selected');
      return;
    }
    var qsBtn = e.target.closest('[data-kk2-quickshop]');
    if (qsBtn) {
      e.preventDefault();
      var handle = qsBtn.getAttribute('data-kk2-quickshop');
      if (window.KK2QuickView) {
        window.KK2QuickView.open(handle);
      } else {
        window.location.href = '/products/' + handle;
      }
    }
  });
})();
